import React from "react";

const LoaderButton = (props) => {
    return (
        <button className={props.className} onClick={props.onClick} disabled={props.isSubmitting || props.disabled}>
            {props.text}
        </button>
    );
};

export default LoaderButton;
